export const gerarRelatorio = (data): void => {
	const blob = new Blob([data], {
		type: "application/pdf",
	});
	const url = window.URL.createObjectURL(blob);
	window.open(url);
};